import ApplyFormCard from '@/components/ApplyFormCard/ApplyFormCard';
import CommunityContactInformation from '@/components/CommunityContactInformation/CommunityContactInformation';
import Hero from '@/components/Hero/Hero';
import { useAppContext } from '@/contexts/AppContext';
import { useUnit } from '@/hooks/units';
import { getRouteApi } from '@tanstack/react-router';
import type { FC } from 'react';

const route = getRouteApi('/_layout/apply');

const ApplyPage: FC = () => {
  const { community } = useAppContext();
  const { unitId } = route.useSearch();
  const { data: unit } = useUnit.useQuery([community.id, unitId]);

  if (!unit) {
    return null;
  }

  return (
    <div>
      <Hero
        title="Apply Now"
        subtitle="Start your application to make our community your new home"
        showCTA={false}
      />
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col lg:grid lg:grid-cols-2 gap-12 items-start">
            <div className="lg:sticky top-24 order-1 lg:order-2">
              <ApplyFormCard unit={unit} />
            </div>
            <CommunityContactInformation
              unitId={unitId}
              title="Application Process"
              detail="Ready to call our community home? Complete the application form to get started. Our team will review your application and contact you within 24-48 hours."
              showScheduleTourLink
              className="order-2 lg:order-1"
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default ApplyPage;
